//Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
//Modules
import { SharedModule } from '../../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
//Components
import { EmailAddressComponent } from './email-address/email-address.component';
import { WelcomeCodeComponent } from './welcome-code/welcome-code.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
	declarations: [WelcomeCodeComponent, EmailAddressComponent],
	exports: [WelcomeCodeComponent, EmailAddressComponent],
	imports: [
		CommonModule,
		SharedModule,
		TranslateModule,
		RouterModule,
		ReactiveFormsModule,
	],
})
export class ComponentsAuthModule {}
